<template>
  <div class="rankList wrap">
    <div class="rankList-header">
      <div class="todo-title-left-text">学时榜</div>
    </div>
    <div class="rankList-content">
      <div class="lawyer-refund-wrap">
        <div class="content">
          <div
            v-for="(item, index) in rankList"
            :key="index"
            :style="{ width: `calc(50% - ${(1) * 10}px)` }"
            class="card-item"
          >
            <div class="left">
              <div class="number">{{ index + 1 }}</div>
              <div class="team-name">{{ item.username }}</div>
            </div>
            <div class="right">
              <div class="case-num">总学时：{{ item.classHour }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHourBd } from "@/api/course";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "rankList",
  data() {
    return {
      rankList: [],
    };
  },
  created() {
    this.getHourBd();
  },
  methods: {
    // 获取学时榜
    async getHourBd() {
      try {
        const res = await getHourBd();
        this.rankList = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.rankList {
  margin: 20px auto;

  .rankList-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #e9e9e9;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    background: #fff;
  }
  .rankList-content {
    min-height: 200px;
    padding: 10px 20px;
    background: #fff;
    .rankItem {
      display: flex;
      align-items: center;
      height: 40px;
      background: hsl(0, 0%, 90%);
      border-radius: 5px;
      .rank {
        font-size: 16px;
        font-weight: 700;
        margin-right: 200px;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        &:first-child {
          color: red;
        }
      }
      .name {
        font-size: 16px;
        margin-right: 200px;
      }
    }
    .lawyer-refund-wrap {
      background: #fff;
      //   border: 1px solid #ebeaf0;
      border-radius: 4px;
      .content {
        display: flex;
        // align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        // padding: 15px 50px;
        .card-item {
          position: relative;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
            justify-content: space-between;
          background-color: #e7ebf1;
          padding: 10px 50px 10px 20px;
          border-radius: 4px;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 0;
            border-bottom: 40px solid white;
            border-left: 10px solid transparent;
          }
          &:nth-child(1) {
            .number {
              color: red;
            }
          }
          &:nth-child(2) {
            .number {
              color: #e5794a;
            }
          }
          &:nth-child(3) {
            .number {
              color: #2893e0;
            }
          }
          .left,
          .right {
            display: flex;
            align-items: center;
          }

          // .left {
          //   margin-right: 150px;
          // }
          .number {
            margin-right: 10px;
          }
          .team-name {
            font-size: 14px;
            font-weight: 600;
            // margin-right: 100px;
          }
          .case-num {
            margin-right: 20px;
          }
          .refund-money {
          }
        }
      }
    }
  }

  .todo-title-left-text{
    color: #558ad6;
  }
}

// 适配移动端

@media (max-width: 600px) {
  .card-item {
   width: 100% !important;
   display: flex;
   justify-content: space-between;
  
  }
}

</style>
